import React from "react"
import SettingsIntermediate from "../SettingsIntermediate"
import userPermissions from "../../User/Permissions";
import { getSession } from "../../../auth";
import WhatsAppVoiceGeneralComponent from "../../Settings/WhatsAppVoice/General"
import WhatsAppVoiceMessageComponent from "../../Settings/WhatsAppVoice/Message"

const WhatsAppVoicePage = () => {
    const groups = userPermissions();
    const enterprise = getSession()?.profile?.enterprise
    return (
        <>
            <SettingsIntermediate title="Telefonia WhatsApp" components={() => ({
                comp1:{
                    permissions: true,
                    style:"title",
                    label:"Telefonia WhatsApp"
                },
                comp2:{
                    permissions: groups.isAdmin,
                    style:"list",
                    label:"Geral",
                    sublabel:"Configurações gerais da telefonia WhatsApp",
                    redirect: (<WhatsAppVoiceGeneralComponent enterpriseId={enterprise?.id}/>),
                },
                comp3:{
                    permissions: groups.isAdmin,
                    style:"list",
                    label:"Mensagens",
                    sublabel:"Configure as mensagens pre-programadas para a telefonia WhatsApp",
                    redirect: (<WhatsAppVoiceMessageComponent enterpriseId={enterprise?.id}/>),
                },
            })
            } />
        </>
    )
}


export default WhatsAppVoicePage
